export default "__VITE_ASSET__B7sq80rU__"